export default __webpack_public_path__ + "static/media/moneyhash_card.0dc1991d.svg";